export default {
  footerLink: 'Cookie-inställningar',
  consentModal: {
    title: 'Vi använder cookies',
    description: 'Vi använder ett minimum av cookies för att webbplatsen ska fungera, samt valfria analys- och annonscookies — endast med ditt samtycke.',
    acceptAllBtn: 'Acceptera alla',
    acceptNecessaryBtn: 'Avvisa alla',
    showPreferencesBtn: 'Hantera inställningar',
  },
  preferencesModal: {
    title: 'Cookie-inställningar',
    acceptAllBtn: 'Acceptera alla',
    acceptNecessaryBtn: 'Avvisa alla',
    savePreferencesBtn: 'Spara inställningar',
    closeIconLabel: 'Stäng',
    sections: [
      {
        title: 'Nödvändiga',
        description: 'Dessa cookies krävs för att webbplatsen ska fungera och kan inte stängas av.',
        linkedCategory: 'necessary',
      },
      {
        title: 'Analys',
        description: 'Hjälper oss förstå hur webbplatsen används så att vi kan förbättra den.',
        linkedCategory: 'analytics',
      },
      {
        title: 'Annonsering',
        description: 'Används för att göra annonser mer relevanta. Aktiveras endast med ditt samtycke.',
        linkedCategory: 'ads',
      },
    ],
  },
}
